import { useEffect, useState } from "react";
import { Box, Button, makeStyles } from "@material-ui/core";
import PricingGroupSelection from "../pricinggroup/PricingGroupSelection";
import PricingGroupMaterialSelectionDialog from "./PricingGroupMaterialSelectionDialog";
import usePricingGroupApi, { PricingGroup } from "../../api/PricingGroupApi";

interface Props {
  readonly customerId: number;
  readonly priceListId: number;
  readonly onPricingGroupAssignmentClosed: () => void;
  readonly onPricingGroupIdSet: (pricingGroupId: number) => void;
}

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3)
  },
  button: {
    margin: theme.spacing(1)
  },
  currentPricingGroup: {
    margin: theme.spacing(1)
  }
}));

const CustomerPricingGroup = (props: Props) => {
  const classes = useStyles();
  const pricingGroupApi = usePricingGroupApi()
  const customerId = props.customerId;
  const [pricingGroupMaterialSelectionDialogOpen, setPricingGroupMaterialSelectionDialogOpen] = useState<boolean>(false);
  const [selectedPricingGroupId, setSelectedPricingGroupId] = useState<number>();
  const [assignedPricingGroup, setAssignedPricingGroup] = useState<PricingGroup|null>(null);

  const updateSelectedPricingGroup = (pricingGroup: PricingGroup) => {
    const pricingGroupId = pricingGroup.id;
    setSelectedPricingGroupId(pricingGroupId);
    props.onPricingGroupIdSet(pricingGroupId);
  };

  const handlePricingGroupSelected = updateSelectedPricingGroup;

  const handleAssignPricingGroupClicked = () => {
    setPricingGroupMaterialSelectionDialogOpen(true);
  };

  const handlePricingGroupMaterialSelectionDialogClosed = () => {
    setPricingGroupMaterialSelectionDialogOpen(false);
    refreshPricingGroupViews();
    props.onPricingGroupAssignmentClosed();
  };

  const refreshAssignedAndSelectedPricingGroup = (pricingGroup: PricingGroup|null) => {
    setAssignedPricingGroup(pricingGroup);
    if (pricingGroup !== null) {
      updateSelectedPricingGroup(pricingGroup);
    }
  };

  const refreshPricingGroupViews = () => {
    pricingGroupApi
      .fetchCustomerPricingGroup(customerId)
      .then(refreshAssignedAndSelectedPricingGroup)
      .catch(error => {
        console.warn(`No pricing group assigned to the customer #${customerId}: ${JSON.stringify(error)}`);
        if (error.status === 404) {
          refreshAssignedAndSelectedPricingGroup(null);
        }
      });
  };

  useEffect(refreshPricingGroupViews, [customerId]);

  return <Box className={classes.root}>
    <div className={classes.currentPricingGroup}>
      { assignedPricingGroup === null
        ? 'Brak aktualnie przypisanej grupy cenowej do klienta'
        : `Aktualnie przypisana do klienta grupa cenowa: ${ assignedPricingGroup.name }`
      }
    </div>
    <Box display='flex' flexDirection='row'>
      <PricingGroupSelection
        customerId={ customerId }
        assignedPricingGroup={ assignedPricingGroup }
        selectedPricingGroupId={ selectedPricingGroupId }
        onPricingGroupSelected={ handlePricingGroupSelected } />
      <Button
        color='primary'
        className={ classes.button }
        onClick={ handleAssignPricingGroupClicked }
        variant='contained'>
          Zastosuj grupę cenową do cennika klienta
      </Button>
    </Box>
    <PricingGroupMaterialSelectionDialog
      customerId={ customerId }
      priceListId={ props.priceListId }
      pricingGroupId={ selectedPricingGroupId }
      open={ pricingGroupMaterialSelectionDialogOpen }
      onDialogClosed={ handlePricingGroupMaterialSelectionDialogClosed }
    />
  </Box>;
};

export default CustomerPricingGroup;